import React from 'react';

import { isValidMotionProp, motion } from 'framer-motion';
import { type HTMLMotionProps } from 'framer-motion';

import {
  chakra,
  shouldForwardProp,
  type HTMLChakraProps,
} from '@chakra-ui/react';

type MotionBoxProps = Omit<
  HTMLMotionProps<'div'>,
  keyof HTMLChakraProps<'div'>
> &
  HTMLChakraProps<'div'>;

const ChakraMotionDiv = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
}) as React.FC<MotionBoxProps>;

export const MotionBox: React.FC<MotionBoxProps> = (props) => {
  return <ChakraMotionDiv {...props} />;
};
